/**
 * Sends the initial verification message without turning a temporary mail
 * failure into a failed account creation.
 *
 * The returned status is explicit so the interface never claims that a real
 * email was delivered when the Auth emulator handled the request.
 */
export async function sendInitialVerificationEmail(
  user,
  { sendEmail, isEmulator = false }
) {
  try {
    await sendEmail(user);
    return { status: isEmulator ? "emulated" : "sent" };
  } catch (error) {
    console.warn("[auth] email de verification non envoye:", error);
    return {
      status: "failed",
      errorCode: typeof error?.code === "string" ? error.code : null,
    };
  }
}
